import { Money } from '@dreryk/money-common-api';

import { TextView } from '@dreryk/react-components';
import { getCustomFormattingContext, priceFormatter } from '@dreryk/react-common';

import { translationKeys } from '../translations';

type AdvancePaymentAmountTextViewProps = Readonly<{ amount: Money | null }>;

const EMPTY_PLACEHOLDER = '-';

export const AdvancePaymentAmountTextView = (props: AdvancePaymentAmountTextViewProps): JSX.Element => {
   return (
      <TextView testId={'advancePaymentAmount'} label={translationKeys.advancePaymentAmount}>
         {props.amount
            ? priceFormatter(
                 props.amount.asNumber(),
                 getCustomFormattingContext({
                    options: {
                       currency: 'PLN',
                       stripDecimalZeroes: true,
                    },
                 })
              )
            : EMPTY_PLACEHOLDER}
      </TextView>
   );
};
